// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem } from 'components';
import React, { ReactElement } from 'react';
import './authorizationTechnical.scss';
import { useTranslation } from 'react-i18next';
import useCheckColor from 'store/hooks/useCheckColor';
import {
  AuthorizationTechnicalModel,
  AuthorizationTechnicalPlaceOfValidityDetail,
} from 'api/types/Technical';

interface Props {
  userId: number | null;
  dataAuthorizationTechnical: AuthorizationTechnicalModel[] | null | undefined;
}

const AuthorizationTechnical = (props: Props): ReactElement => {
  const { userId, dataAuthorizationTechnical } = props;
  const { t } = useTranslation('employee');

  //   START Color

  const checkColor = useCheckColor();

  // END Color

  const place = (
    placeOfValidity: AuthorizationTechnicalPlaceOfValidityDetail
  ): string => {
    let toReturn = placeOfValidity.name;

    if (
      placeOfValidity.description !== null &&
      placeOfValidity.description !== ''
    ) {
      toReturn += ` - ${placeOfValidity.description}`;
    }

    return toReturn;
  };

  return (
    <>
      {dataAuthorizationTechnical &&
      dataAuthorizationTechnical !== null &&
      Object.keys(dataAuthorizationTechnical)?.length > 0 ? (
        <Box
          id="userAuthorizationTechnicalBox"
          name={t('userAuthorizationTechnical.authorizationTechnical')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userAuthorizationTechnicalContent">
            {Object.keys(dataAuthorizationTechnical)?.map((k) => (
              <DesktopItem
                id="qualifications"
                name={dataAuthorizationTechnical?.[k]?.name}
              >
                <>
                  {dataAuthorizationTechnical?.[k]?.positions !== null &&
                  Object.keys(dataAuthorizationTechnical?.[k]?.positions)
                    ?.length > 0 ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t('userAuthorizationTechnical.positions')}
                      </div>
                      <div className="authorizationTechnicalValue">
                        {Object.values(
                          dataAuthorizationTechnical?.[k]?.positions ?? {}
                        ).join(', ')}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationTechnical?.[k]?.authorizationNumber !==
                    null &&
                  dataAuthorizationTechnical?.[k]?.authorizationNumber !== '' &&
                  dataAuthorizationTechnical?.[k]?.authorizationNumber !==
                    ' ' ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t('userAuthorizationTechnical.authorizationNumber')}
                      </div>
                      <div className="authorizationTechnicalValue">
                        {dataAuthorizationTechnical?.[k]?.authorizationNumber}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {dataAuthorizationTechnical?.[k]
                    ?.technicalQualificationEmployee !== null &&
                  dataAuthorizationTechnical?.[k]
                    ?.technicalQualificationEmployee?.length > 0 ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t(
                          'userAuthorizationTechnical.qualificationEnergyToAuthorization'
                        )}
                      </div>
                      <div className="authorizationTechnicalValue">
                        {dataAuthorizationTechnical?.[
                          k
                        ]?.technicalQualificationEmployee?.map((item) => (
                          <div key={item.id}>{item.qualificationName}</div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {dataAuthorizationTechnical?.[k]
                    ?.authorizationDictionaryDetail !== null &&
                  dataAuthorizationTechnical?.[k]?.authorizationDictionaryDetail
                    ?.length > 0 ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t(
                          'userAuthorizationTechnical.authorizationToOperateEquipment'
                        )}
                      </div>
                      <div className="authorizationTechnicalValue">
                        {dataAuthorizationTechnical?.[
                          k
                        ]?.authorizationDictionaryDetail
                          ?.map((item) => item.name)
                          .join(',')}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationTechnical?.[k]?.placeOfValidity &&
                  dataAuthorizationTechnical?.[k]?.placeOfValidity !== null ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t('userAuthorizationTechnical.placeOfValidity')}
                      </div>
                      <div className="authorizationTechnicalValue">
                        {place(
                          dataAuthorizationTechnical?.[k]?.placeOfValidity
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationTechnical?.[k]
                    ?.authorizationEmployeeDetailCurrent !== null &&
                  Object.keys(
                    dataAuthorizationTechnical?.[k]
                      ?.authorizationEmployeeDetailCurrent
                  )?.length ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t(
                          'userAuthorizationTechnical.authorizationDocumentName'
                        )}
                      </div>
                      {dataAuthorizationTechnical?.[
                        k
                      ]?.authorizationEmployeeDetailCurrent?.map((v) => {
                        return (
                          <div className="authorizationTechnicalValue">
                            {v?.authorizationDocumentName}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ''
                  )}

                  {dataAuthorizationTechnical?.[k]?.authorizationDate !==
                  null ? (
                    <div className="authorizationTechnicalDetailBox">
                      <div className="authorizationTechnicalLabel">
                        {t('userAuthorizationTechnical.authorizationDate')}
                      </div>
                      <div className="authorizationTechnicalValue">
                        {dataAuthorizationTechnical?.[k]?.authorizationDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {dataAuthorizationTechnical?.[k]
                    ?.expirationAuthorizationDate !== null ? (
                    <div
                      className={`dateAuthorizationTechnicalBox ${checkColor(
                        dataAuthorizationTechnical?.[k]
                          ?.expirationAuthorizationDate,
                        'uprawnienia',
                        'upowaznieniaTechniczne'
                      )}`}
                    >
                      <div
                        className={`dateAuthorizationTechnicalLabel ${checkColor(
                          dataAuthorizationTechnical?.[k]
                            ?.expirationAuthorizationDate,
                          'uprawnienia',
                          'upowaznieniaTechniczne'
                        )}`}
                      >
                        {t(
                          'userAuthorizationTechnical.expirationAuthorizationDate'
                        )}
                      </div>
                      <div
                        className={`dateAuthorizationTechnicalValue ${checkColor(
                          dataAuthorizationTechnical?.[k]
                            ?.expirationAuthorizationDate,
                          'uprawnienia',
                          'upowaznieniaTechniczne'
                        )}`}
                      >
                        {
                          dataAuthorizationTechnical?.[k]
                            ?.expirationAuthorizationDate
                        }
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="borderTop" />
                </>
              </DesktopItem>
            ))}
          </div>
        </Box>
      ) : null}
    </>
  );
};

export default AuthorizationTechnical;
